import { observer } from 'mobx-react';
import React from 'react';
import { IBaseOption } from './utils';
import { IBaseSelect, LFBaseSelect } from './LFBaseSelect';
export type IAsyncSelect<T extends IBaseOption, IsMulti extends boolean = false> = Omit<IBaseSelect<T, IsMulti>, 'useAsync' | 'withNumberSelectUnitDefault'>;
export const LFAsyncSelect = observer(<T extends IBaseOption, IsMulti extends boolean = false>(props: IAsyncSelect<T, IsMulti>) => <LFBaseSelect<T, IsMulti> {...props} useAsync />);